import { register } from 'register-service-worker'

// O app vem do cache do service worker. Para pegar deploy novo sem o bagre ter que fechar tudo:
// 1. procura versão nova ao voltar para o app e a cada hora (o PWA instalado quase nunca "navega");
// 2. quando a versão nova assume (skipWaiting + clientsClaim no vue.config.js), recarrega a página.
const CHECK_INTERVAL_MS = 60 * 60 * 1000

if ('serviceWorker' in navigator) {
  // sem controller = primeira instalação: nada a recarregar
  const hadController = !!navigator.serviceWorker.controller
  let reloading = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return
    reloading = true
    window.location.reload()
  })
}

register(`${process.env.BASE_URL}service-worker.js`, {
  registered (registration) {
    const check = () => registration.update().catch(() => { /* offline: tenta na próxima */ })
    setInterval(check, CHECK_INTERVAL_MS)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check()
    })
  },
  error (error) {
    console.error('Error during service worker registration:', error)
  }
})
